import type { ReactNode } from "react";
import { twJoin } from "tailwind-merge";

import barChart02Icon from "@/assets/icons/bar-chart-02.svg";

const SORT_DIRECTION_CLASSES = {
  ascending: "-rotate-90",
  descending: "rotate-90",
} as const;

export function SortDirectionIcon({ direction }: { direction: keyof typeof SORT_DIRECTION_CLASSES }): ReactNode {
  return (
    <span aria-hidden="true" className={twJoin("block shrink-0 fill-transparent", SORT_DIRECTION_CLASSES[direction])}>
      <svg width={16} height={16}>
        <use xlinkHref={`#${barChart02Icon}`} />
      </svg>
    </span>
  );
}
